import React from 'react'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { RESP_DISTRESS_OPTIONS } from '../../../_pewsCalc'

const RespDistress = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <FormControl fullWidth>
      <InputLabel>Respiratory Distress</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label="Respiratory Distress"
      >
        {RESP_DISTRESS_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default RespDistress
